import { render, staticRenderFns } from "./SuItem.vue?vue&type=template&id=7ccc6708&scoped=true&"
import script from "./SuItem.vue?vue&type=script&lang=js&"
export * from "./SuItem.vue?vue&type=script&lang=js&"
import style0 from "./SuItem.vue?vue&type=style&index=0&id=7ccc6708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccc6708",
  null
  
)

export default component.exports